  <template>
  <div>
    <div class="inline-wrapper bettinfo-date">
      <el-radio-group v-model="fastData" @change="fastDataChange">
        <el-radio-button label="Today" :class="{'is-active': firstActive}"></el-radio-button>
        <el-radio-button label="3 days"></el-radio-button>
        <el-radio-button label="7 days"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        class="bet-date-picker"
        v-model="freeDate"
        type="daterange"
        range-separator="-"
        start-placeholder="Start Time"
        end-placeholder="End Time"
        format="yyyy-MM-dd"
        value-format="timestamp"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="pickerOptions"
        :unlink-panels="true"
        @change="dataTimeChange"
      ></el-date-picker>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Login Time" min-width="223">
          <template v-slot="{row}">
            <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Login IP" prop="loginIp" min-width="224"></el-table-column>
        <el-table-column label="Region" prop="loginRegion" min-width="279"></el-table-column>
        <el-table-column label="Device" prop="loginTerminalType" min-width="222"></el-table-column>
        <el-table-column label="Device ID" prop="loginDeviceId" min-width="223"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.pageSize"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import { getLoginLog } from "@/api/memberDetail";
export default {
  name: "RiskDetail",
  components: {
    Empty
  },
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      fastData: "",
      freeDate: [],
      firstActive: false,
      loading: false,
      queryData: {
        userId: 0,
        loginStartTime: "",
        loginEndTime: "",
        current: 1,
        pageSize: 20
      },
      lableList: [],
      tableHeight: window.innerHeight,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
          if (maxDate) {
            this.curDate = "";
          }
        },
        disabledDate: time => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.curDate - one;
            const maxTime = this.curDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      }
    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 150;
        });
      }
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 115;
        });
      }
    }
  },
  methods: {
    async getList() {
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getLoginLog(this.queryData);
        const data = res.data || {};
        this.list = data.record || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    fastDataChange(time) {
      this.firstActive = false;
      let d = [];
      if (time === "Today") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime(),
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      if (time === "7 days") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            6 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      if (time === "3 days") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            2 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      this.queryData.loginStartTime = d[0];
      this.queryData.loginEndTime = d[1];
      this.freeDate = d;
      this.getList();
    },
    dataTimeChange([startTime, endTime]) {
      this.firstActive = false;
      this.queryData.loginStartTime = startTime;
      this.queryData.loginEndTime = endTime;
      this.fastData = "";
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    const start = this.$moment(this.freeDate[0]).startOf("month"); //  当月第一天时间
    const end = this.$moment(this.freeDate[1]).endOf("month"); //  当月最后一天
    this.queryData.loginStartTime = start.valueOf();
    this.queryData.loginEndTime = end.valueOf();
    this.freeDate = [start.valueOf(), end.valueOf()];
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.bettinfo-date {
  font-size: 12px;
  margin: 0 0 15px 0;
}
</style>
